/**
 * Zopup - Audit API
 * Zopup - Audit API
 *
 * OpenAPI spec version: v1
 * Contact: djoyrocks@gmail.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export class BizError {
    message?: string;
    errorCode?: number;
    errorId?: string;
    description?: string;
}
